import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'adahi-btn-toggle',
  templateUrl: './btn-toggle.component.html'
})
export class BtnToggleComponent implements OnInit {
  ngOnInit(): void {
  }

  @Output() changed = new EventEmitter<boolean>();

  @Input() text: string;
  @Input() id: string;
  @Input() isChecked: boolean = true;
  @Input() isDisabled: boolean = false;
}